// Local translations
export const T = {
  en_GB: {
    name: "Name",
    active: "Active",
    lastUsed: "Last Used",
    created: "Created",
    actions: "Actions",
    never: "Never",
    noApiKeysYet: "No API keys yet. Create your first API key to get started.",
    deleteApiKey: "Delete API Key",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    ok: "OK",
    failedToDeleteApiKey: "Failed to delete API key",
    failedToToggleApiKey: "Failed to toggle API key",
  },
  nb_NO: {
    name: "Navn",
    active: "Aktiv",
    lastUsed: "Sist brukt",
    created: "Opprettet",
    actions: "Handlinger",
    never: "Aldri",
    noApiKeysYet: "Ingen API-nøkler ennå. Opprett din første API-nøkkel for å komme i gang.",
    deleteApiKey: "Slett API-nøkkel",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    ok: "OK",
    failedToDeleteApiKey: "Kunne ikke slette API-nøkkel",
    failedToToggleApiKey: "Kunne ikke endre API-nøkkel",
  },
} as const;
